<div class="sbd-dd" [class.sbd-dd--open]="isOpen()" [class.sbd-dd--multiple]="multiple">
  <button
    type="button"
    class="sbd-dd__trigger"
    aria-haspopup="listbox"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-label]="accessibleSummary || null"
    [disabled]="disabled"
    (click)="toggle()"
    (keydown)="onTriggerKeydown($event)"
  >
    @if (multiple) {
      <span class="sbd-dd__chips">
        @for (option of selectedOptions; track option.value) {
          <span class="sbd-dd__chip">{{ option.label }}</span>
        } @empty {
          <span class="sbd-dd__placeholder">{{ placeholder }}</span>
        }
      </span>
    } @else {
      <span>
        @if (prefix) {
          <span class="sbd-dd__prefix">{{ prefix }}</span>
        }
        <span class="sbd-dd__value">{{ selectedLabel }}</span>
      </span>
    }
    <svg class="sbd-dd__chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  </button>

  @if (isOpen()) {
    <div
      class="sbd-dd__panel"
      [class.sbd-dd__panel--right]="align === 'right'"
      [class.sbd-dd__panel--up]="openUp"
      role="listbox"
      [attr.aria-label]="ariaLabel || null"
      [attr.aria-multiselectable]="multiple || null"
      (keydown)="onPanelKeydown($event)"
    >
      @for (option of options; track option.value) {
        <button
          type="button"
          class="sbd-dd__option"
          role="option"
          [class.sbd-dd__option--selected]="isSelected(option)"
          [class.sbd-dd__option--locked]="isLocked(option)"
          [attr.aria-selected]="isSelected(option)"
          [attr.aria-disabled]="isLocked(option) || null"
          [title]="isLocked(option) ? 'At least one option must stay selected' : ''"
          (click)="select(option)"
        >
          <span class="sbd-dd__check" [class.sbd-dd__check--on]="isSelected(option)" aria-hidden="true"></span>
          <span class="sbd-dd__option-label">{{ option.label }}</span>
          @if (option.suffix) {
            <span class="sbd-dd__option-suffix">{{ option.suffix }}</span>
          }
        </button>
      }
    </div>
  }
</div>
